export default __webpack_public_path__ + "static/media/background_start.11a86e90.jpg";